export class Newsticker {
	constructor(target: HTMLElement) {
		const motionQuery: MediaQueryList = matchMedia('(prefers-reduced-motion)');

		if (motionQuery.matches) {
			return;
		}

		const ticker: HTMLElement = target.querySelector('.ticker');
		const content: string = ticker.innerHTML;
		ticker.innerHTML += content;
		ticker.innerHTML += content;
		ticker.innerHTML += content;

		ticker
			.querySelectorAll('ul:not(:first-child),ol:not(:first-child)')
			.forEach((item: HTMLElement) => {
				item.setAttribute('aria-hidden', 'true');
			});

		ticker.style.animationDuration = `${ticker.dataset.speed}s`;
	}
}
